import { useId } from "react";
import { ICheckbox } from "../interfaces";
import { GaCheckbox } from "./gaia/GaCheckbox";

export const Checkbox = (props: ICheckbox) => {

    const { isChecked, onChange, onKeyDown, label, disabled, tabIndex } = props;
    const id = useId();
    
    if (window.useGaiaDesign) {
        return <GaCheckbox {...props} />;
    }
    else 
        return (
            <div className="checkbox">
                <input id={id} type="checkbox"
                    checked={isChecked}
                    onChange={(e) => onChange(e.target.checked)}
                    onKeyDown={onKeyDown} disabled={disabled}
                    tabIndex={tabIndex ? tabIndex : 0} />
                <label className={`d-block ${label ? "pl-8" : ""}`} htmlFor={id}>{label}</label>
            </div>
        );
};

export default Checkbox;